import * as React from 'react';
import type { SVGProps } from 'react';

const SvgDriveOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 56 56"
    {...props}
  >
    <path
      fill="#07036C"
      fillRule="evenodd"
      d="m29.717 21.39 3.892 11.569v14.875h-4.824v-3.306H9.49v3.306H4.666V32.959l3.907-11.57zm-14.6 17.353v4.132h8.04v-4.132zm-4.823-4.132c-1.335 0-2.412 1.108-2.412 2.48s1.077 2.479 2.412 2.479 2.412-1.108 2.412-2.48-1.078-2.479-2.412-2.479m17.687 0c-1.335 0-2.412 1.108-2.412 2.48s1.077 2.479 2.412 2.479 2.412-1.108 2.412-2.48-1.078-2.479-2.412-2.479M10.294 23.868l-2.412 7.438h22.51l-2.411-7.438z"
      clipRule="evenodd"
    />
    <path
      fill="#07036C"
      d="M44.864 31.306h6.432v16.528h-6.432zM23.961 10.778l1.972-2.611 25.4 20.263-1.972 2.611z"
    />
    <path fill="#07036C" d="M46.07 28h2.814l1.206 1.653v3.306h-4.02z" />
  </svg>
);
export default SvgDriveOut;
